import Layout from "../../Common/Components/Layout/Layout";
import style from "./Settings.module.css";
import React from "react";
 


const Settings = () => {
  return (
    <>
      <div className="App">
            <div className="coming-soon">
                Settings Chat feature will be Coming Soon !!!
            </div>
      </div>
    </>
  );
};

export default Layout(Settings);
